import languages from './languages';

function newLocation() {
    let location =  {
        name: '',
        labels: {},
        type: null,
        xmlType: null,
        typeDescription: null,
        latitude: null,
        longitude: null,
        slugs: {
            default: ''
        },
        feature: null,
        bbox: null,
        relations: []
    };

    languages.forEach( lang => {
        location.labels[ lang.code ] = '';
        location.slugs[ lang.code ] = '';
    } );

    return location;
}

export {
    newLocation
};



// WEBPACK FOOTER //
// ./src/models/location.js